<template>
  <de-layout-content :noPadding="true">
    <div slot="header" class="spcBt">
      <span class="tit">角色管理</span>
    </div>
    <el-form :model="queryParams" ref="queryForm" :inline="true" size="mini" class="ant-advanced-search-form">
      <el-form-item label="角色名称" prop="name">
        <el-input v-model="queryParams.name" placeholder="输入角色名称" style="width: 160px"
          @keyup.enter.native="handleQuery"></el-input>
      </el-form-item>
      <el-form-item label="组织架构" prop="orgId">
        <el-select v-model="queryParams.orgId" clearable filterable placeholder="选择组织架构">
          <el-option v-for="item in selectDepts" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="角色类型" prop="roleType">
        <el-select v-model="queryParams.roleType" clearable filterable placeholder="选择角色类型">
          <el-option v-for="item in rolesSelect" :key="item.key" :label="item.value" :value="item.key">
          </el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="状态:" prop="userStatus">
          <el-select v-model="queryParams.userStatus" placeholder="状态选择" clearable style="width: 180px">
            <el-option v-for="(item, index) in status" :key="index" :label="item.name" :value="item.value" />
          </el-select>
        </el-form-item> -->
      <el-form-item>
        <el-button size="mini" type="primary" icon="el-icon-search" @click="handleQuery">查询</el-button>
        <el-button size="mini" icon="el-icon-refresh-left" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>
    <el-button size="mini" type="primary" icon="el-icon-plus" style="margin-bottom: 22px"
      @click="handleAdd">新增角色</el-button>
    <el-table v-loading="loading" element-loading-text="加载中" :data="list">
      <el-table-column label="序号" align="center" type="index" width="80" />
      <el-table-column label="角色名称" align="center" prop="remark" />
      <el-table-column label="角色类型" align="center">
        <template slot-scope="scope">
          {{ roleFilter(scope.row.roleType).length ? roleFilter(scope.row.roleType)[0].value : '' }}
        </template>
      </el-table-column>
      <el-table-column label="成员人数" align="center" prop="memberCount" />
      <el-table-column label="组织架构" align="center" min-width="150">
        <template slot-scope="scope">
          <div class="organizationView" v-if="scope.row.orgName">
            <el-tag class="tag" v-for="item in scope.row.orgName.split(',')" size="small">{{ item }}</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="添加人" align="center" prop="createName" />
      <el-table-column label="添加时间" align="center" prop="createTime">
        <template slot-scope="scope">
          {{ moment(scope.row.createTime).format('YYYY-MM-DD HH:mm:ss') }}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="320">
        <template slot-scope="scope">
          <!-- <el-button size="small" plain type="primary" @click="handleDetail(scope.row)" >Web详情</el-button> -->
          <!-- <el-button size="small" plain type="primary" @click="appDetail(scope.row)">APP详情</el-button> -->
          <el-button size="small" plain type="primary" @click="handleApp(scope.row)">APP权限</el-button>
          <el-button size="small" plain type="primary" @click="handleWeb(scope.row)">Web权限</el-button>
          <el-dropdown style="margin-left: 10px" @command="handleCommand">
            <el-button size="small" type="primary">
              <i class="el-icon-more"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="{ action: 'edit', row: scope.row }">
                <div class="commandBtn">
                  <i class="el-icon-edit primary"></i>
                  <span class="primary">编辑</span>
                </div>
              </el-dropdown-item>
              <el-dropdown-item v-if="scope.row.name" :command="{ action: 'delete', row: scope.row }">
                <div class="commandBtn">
                  <i class="el-icon-delete danger"></i>
                  <span class="danger">删除</span>
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <!--            <el-button size="small" plain type="danger" @click="handleDel(scope.row)" v-if="scope.row.name">删除</el-button>-->
        </template>
      </el-table-column>
    </el-table>

    <pagination v-show="total > queryParams.pageSize" :total="total" :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize" @pagination="_getList" />

    <!-- 添加角色 -->
    <el-dialog :title="title" :visible.sync="open" width="600px" class="roleDialog" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="140px">
        <el-form-item label="角色名称" prop="remark">
          <el-input v-model="form.remark" placeholder="请输入角色名称" :disabled="formDisabled" />
        </el-form-item>
        <el-form-item label="角色类型" prop="roleType">
          <el-select v-model="form.roleType" placeholder="请选择角色类型" style="width: 100%" :disabled="formDisabled"
            @change="roleTypeChangeHandle">
            <el-option v-for="item in rolesSelect" :key="item.key" :label="item.value" :value="item.key">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="状态">
            <el-radio-group v-model="form.status">
              <el-radio v-for="dict in dict.type.sys_normal_disable" :key="dict.value"
                :label="dict.value">{{dict.label}}</el-radio>
            </el-radio-group>
          </el-form-item> -->
        <el-form-item label="关联组织结构" prop="orgIds" v-if="form.roleType != 1">
          <el-select v-model="form.orgIds" multiple clearable filterable placeholder="请选择组织结构" style="width: 100%">
            <el-option v-for="item in selectDepts" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="description">
          <el-input v-model="form.description" type="textarea" resize="none" placeholder="请输入内容"
            :disabled="formDisabled"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" v-if="!formDisabled">
        <el-button @click="open = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>

    <!-- Web权限 -->
    <el-dialog :title="title" :visible.sync="webOpen" width="720px" class="roleDialog" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="角色名称">
          <span class="txt-white">{{ form.remark || form.name }}</span>
        </el-form-item>
        <el-form-item label="角色类型">
          <span class="txt-white">{{ roleFilterHandle(form.roleType) }}</span>
        </el-form-item>
        <el-form-item label="菜单权限" prop="menuIds">
          <el-checkbox v-model="menuExpand" :disabled="formDisabled"
            @change="handleCheckedTreeExpand($event, 'dept')">展开/折叠</el-checkbox>
          <el-checkbox v-model="menuNodeAll" :disabled="formDisabled"
            @change="handleCheckedTreeNodeAll($event, 'dept')">全选/全不选</el-checkbox>
          <el-checkbox v-model="form.menuCheckStrictly" :disabled="formDisabled"
            @change="handleCheckedTreeConnect($event, 'dept')">父子联动</el-checkbox>
          <el-tree class="tree-border" :data="menuOptions" show-checkbox ref="dept" node-key="id"
            :class="{ 'onlyRead': formDisabled }" :default-expanded-keys="expandKeys"
            :check-strictly="!form.menuCheckStrictly" :default-checked-keys="form.menuIds" empty-text="加载中，请稍候"
            :props="defaultProps">
            <span class="custom-tree-node" slot-scope="{ node, data }">{{ node.label }} {{ data.remark ||
              ''}}</span></el-tree>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" v-if="!formDisabled">
        <el-button @click="webOpen = false">取 消</el-button>
        <el-button type="primary" @click="webSubmit">确 定</el-button>
      </div>
    </el-dialog>
    <!-- APP权限 -->
    <el-dialog :title="title" :visible.sync="appOpen" width="720px" class="roleDialog" append-to-body>
      <el-form ref="appForm" :model="appForm" :rules="rules" label-width="100px">
        <el-form-item label="角色名称">
          <span class="txt-white">{{ appForm.remark || appForm.name }}</span>
        </el-form-item>
        <el-form-item label="角色类型">
          <span class="txt-white">{{ roleFilterHandle(appForm.roleType) }}</span>
        </el-form-item>
        <el-form-item label="菜单权限" prop="menuIds">
          <el-checkbox v-model="appExpand" :disabled="formDisabled"
            @change="appCheckedTreeExpand($event, 'dept')">展开/折叠</el-checkbox>
          <el-checkbox v-model="appNodeAll" :disabled="formDisabled"
            @change="appCheckedTreeNodeAll($event, 'dept')">全选/全不选</el-checkbox>
          <el-checkbox v-model="appForm.menuCheckStrictly" :disabled="formDisabled"
            @change="appCheckedTreeConnect($event, 'dept')">父子联动</el-checkbox>

          <el-tree class="tree-border" :data="appTree" show-checkbox ref="appTree" node-key="id"
            :class="{ 'onlyRead': formDisabled }" :check-strictly="!appForm.menuCheckStrictly"
            :default-checked-keys="appForm.menuIds" empty-text="加载中，请稍候" :props="defaultProps"
            :default-expanded-keys="expandKeys">
            <span class="custom-tree-node" slot-scope="{ node, data }">{{ node.label }} {{ data.remark ||
              ''}}</span></el-tree>

        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" v-if="!formDisabled">
        <el-button @click="appOpen = false">取 消</el-button>
        <el-button type="primary" @click="appSubmit">确 定</el-button>
      </div>
    </el-dialog>


  </de-layout-content>
</template>

<script>
import moment from "moment";
import * as API_System from "@/api/train/system";
import { structureList } from "@/api/system/mechanism";


export default {
  data() {
    return {
      queryParams: {
        name: '',
        orgId: '',
        roleType: '',
        // userStatus: undefined,
        pageNum: 1,
        pageSize: 10
      },
      status: [
        { name: '正常', value: 1 },
        { name: '禁用', value: 0 }
      ],
      list: [],
      loading: false,
      total: 0,
      rolesSelect: [],
      selectDepts: [],

      menuOptions: [],
      menuExpand: false,
      menuNodeAll: false,
      deptExpand: true,
      deptNodeAll: false,
      form: {
        remark: null,
        roleType: null,
        menuIds: [],
        description: null,
        menuCheckStrictly: true,
        deptCheckStrictly: true,
      },
      formDisabled: false,
      rules: {
        remark: [{ required: true, message: "请输入角色名", trigger: "blur" },],
        roleType: [{ required: true, message: "请选择角色类型", trigger: "blur" },],
        menuIds: [{ required: true, message: "请选择菜单权限", trigger: "change" },],
        orgIds: [{ required: true, message: "请选择组织结构", trigger: "blur  " },],
      },
      open: false,
      webOpen: false,
      title: '',

      appTree: [],
      appForm: {
        menuIds: [],
        deptCheckStrictly: true
      },
      appExpand: false,
      appNodeAll: false,
      appOpen: false,
      expandKeys: []

    };
  },
  components: {
  },
  methods: {
    moment,
    roleFilter(value) {
      return this.rolesSelect.filter(item => item.key == value)
    },
    _getList() {
      this.loading = true;
      API_System.roleList(this.queryParams).then((res) => {
        console.log(res);
        this.total = res.data.itemCount;
        this.list = res.data.listObject;
        setTimeout(() => {
          this.loading = false
        }, 500);
      });
    },
    _allRoles() {
      API_System.roleTypes({}).then(res => {
        console.log(res);
        if (res.success) {
          this.rolesSelect = res.data
        }
      })
    },
    async getMenuTreeselect(type) {
      await API_System.treeSelect({ webType: type }).then(res => {
        console.log(res);
        if (type == 2) this.menuOptions = res.data;
        if (type == 3) this.appTree = res.data;
        this.expandKeys = res.data.map(item => item.id)
      })
    },
    handleQuery() {
      this.queryParams.pageNum = 1;
      this._getList();
    },
    resetQuery() {
      this.$refs["queryForm"].resetFields();
      this.handleQuery();
    },
    handleAdd() {
      this.getMenuTreeselect(2);
      this.open = true;
      this.formDisabled = false
      this.title = "添加角色";
      this.form = {
        remark: null,
        roleType: null,
        menuIds: [],
        orgIds: [],
        description: '',
        menuCheckStrictly: true
      }
    },
    // 树权限（展开/折叠）
    handleCheckedTreeExpand(value, type) {
      if (type == 'menu') {
        let treeList = this.menuOptions;
        for (let i = 0; i < treeList.length; i++) {
          this.$refs.menu.store.nodesMap[treeList[i].id].expanded = value;
        }
      } else if (type == 'dept') {
        let treeList = this.menuOptions;
        for (let i = 0; i < treeList.length; i++) {
          this.$refs.dept.store.nodesMap[treeList[i].id].expanded = value;
        }
      }
    },
    // 树权限（展开/折叠）APP
    appCheckedTreeExpand(value, type) {
      let treeList = this.appTree;
      for (let i = 0; i < treeList.length; i++) {
        this.$refs.appTree.store.nodesMap[treeList[i].id].expanded = value;
      }
    },
    // 树权限（全选/全不选）
    handleCheckedTreeNodeAll(value, type) {
      if (type == 'menu') {
        this.$refs.menu.setCheckedNodes(value ? this.menuOptions : []);
      } else if (type == 'dept') {
        this.$refs.dept.setCheckedNodes(value ? this.menuOptions : []);
      }
    },
    // 树权限（全选/全不选）app
    appCheckedTreeNodeAll(value, type) {
      this.$refs.appTree.setCheckedNodes(value ? this.appTree : []);
    },
    // 树权限（父子联动）
    handleCheckedTreeConnect(value, type) {
      if (type == 'menu') {
        this.form.menuCheckStrictly = value ? true : false;
      } else if (type == 'dept') {
        this.form.deptCheckStrictly = value ? true : false;
      }
    },
    // 树权限（父子联动）app
    appCheckedTreeConnect(value, type) {
      this.appForm.deptCheckStrictly = value ? true : false;
    },
    // 所有部门节点数据
    getDeptAllCheckedKeys(treeName) {
      // 目前被选中的部门节点
      let checkedKeys = this.$refs[treeName].getCheckedKeys();
      // 半选中的部门节点
      let halfCheckedKeys = this.$refs[treeName].getHalfCheckedKeys();
      // console.log(halfCheckedKeys);
      checkedKeys.unshift.apply(checkedKeys, halfCheckedKeys);
      return checkedKeys;
    },
    webSubmit() {
      this.form.menuIds = this.getDeptAllCheckedKeys('dept');
      this.form.name = this.form.remark
      this.$refs["form"].validate((valid) => {
        if (valid) {
          // console.log("onSubmit");
          // console.log(this.form);
          let key = this.form.roleId ? 'editRole' : 'addRole'
          API_System[key](this.form).then(res => {
            console.log(res);
            this.$message.success("操作成功");
            this.webOpen = false;
            this.handleQuery()
          })
        } else {
          this.$message({
            message: "填写数据不全或数据有误",
            type: "error",
          });
          return false;
        }
      });
    },
    submitForm() {
      console.log(this.form)
      // this.form.menuIds = this.getDeptAllCheckedKeys('dept');
      this.form.name = this.form.remark
      this.$refs["form"].validate((valid) => {
        if (valid) {
          // console.log("onSubmit");
          // console.log(this.form);
          let key = this.form.roleId ? 'editRole' : 'addRole'
          API_System[key](this.form).then(res => {
            console.log(res);
            this.$message.success("操作成功");
            this.open = false;
            this.handleQuery()
          })
        } else {
          this.$message({
            message: "填写数据不全或数据有误",
            type: "error",
          });
          return false;
        }
      });
    },
    handleEdit(e) {
      console.log(e);
      this.title = `【${e.remark}】修改角色`;
      this.formDisabled = !e.name
      this.form = {}
      this.getDetail(e, 1)
    },
    getDetail(e, type) {
      this.getMenuTreeselect(2).then(res => {
        this._getRole(e, type)
      })
    },
    handleWeb(e) {
      console.log(e);
      this.title = `【${e.remark}】Web权限`;
      this.formDisabled = !e.name
      this.form = {}
      this.getDetail(e, 2)
    },
    handleApp(e) {
      this.title = `【${e.remark}】APP权限`;
      this.formDisabled = !e.name
      this.appForm = {}
      this.getMenuTreeselect(3).then(res => {
        this._getRole(e, 3)
      })
    },
    appSubmit() {
      this.appForm.menuIds = this.getDeptAllCheckedKeys('appTree');
      this.$refs["appForm"].validate((valid) => {
        if (valid) {
          // console.log("onSubmit");
          // console.log(this.appForm);
          API_System.editAppRole(this.appForm).then(res => {
            console.log(res);
            this.$message.success("操作成功");
            this.appOpen = false;
            this.handleQuery()
          })
        } else {
          this.$message({
            message: "填写数据不全或数据有误",
            type: "error",
          });
          return false;
        }
      });
    },
    roleTypeChangeHandle() {
      if (this.form.roleType == 1) {
        this.form.orgIds = null
        this.rules = {
          remark: [{ required: true, message: "请输入角色名", trigger: "blur" },],
          roleType: [{ required: true, message: "请选择角色类型", trigger: "blur" },],
          menuIds: [{ required: true, message: "请选择菜单权限", trigger: "change" },],
        }
      } else {
        this.rules = {
          remark: [{ required: true, message: "请输入角色名", trigger: "blur" },],
          roleType: [{ required: true, message: "请选择角色类型", trigger: "blur" },],
          menuIds: [{ required: true, message: "请选择菜单权限", trigger: "change" },],
          orgIds: [{ required: true, message: "请选择组织结构", trigger: "blur  " },],
        }
      }
    },
    handleDetail(e) {
      this.formDisabled = true
      this.title = "角色详情";
      this.getDetail(e)
    },
    appDetail(e) {
      this.formDisabled = true
      this.title = "APP详情";
      this.getMenuTreeselect(3).then(res => {
        this._getRole(e, 3)
      })
    },
    getAppList() {
      API_System.treeSelect({ webType: 3 }).then(res => {
        console.log(res);
        this.appTree = res.data
      })
    },
    handleDel(e) {
      this.$confirm(`确定删除该角色？`, "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning",
      })
        .then(() => {
          this._delRole(e)
        })
        .catch(() => { });
    },
    handleCommand(e) {
      if (e.action == 'edit') {
        this.handleEdit(e.row)
      }
      if (e.action == 'delete') {
        this.handleDel(e.row)
      }
    },
    // 接口-删除角色
    _delRole(e) {
      API_System.delRole(e.roleId).then(res => {
        console.log(res);
        this.$message({ message: "已删除" });
        this.open = false;
        this.handleQuery()
      })
    },
    // 接口-角色信息
    _getRole(e, type) {
      API_System.roleInfo(e.roleId).then(res => {
        console.log(res);
        res.data.orgIds = res.data.hashMaps.map(item => item.organization_id)
        if (type == 1) {
          this.form = JSON.parse(JSON.stringify(res.data))
          this.form.menuIds = this.form.sysMenuIds ? this.form.sysMenuIds.split(',') : []
          // this.$set(this.form,'menuCheckStrictly', true)
          this.open = true;
        }
        if (type == 2) {
          this.form = JSON.parse(JSON.stringify(res.data))
          this.form.menuIds = this.form.sysMenuIds ? this.form.sysMenuIds.split(',') : []
          // this.$set(this.form,'menuCheckStrictly', true)
          this.webOpen = true;
        }
        if (type == 3) {
          this.appForm = JSON.parse(JSON.stringify(res.data))
          this.appForm.menuIds = this.appForm.sysMenuIds ? this.appForm.sysMenuIds.split(',') : []
          // this.$set(this.appForm,'menuCheckStrictly', true)
          this.appOpen = true;
        }
        this.$forceUpdate()
      })
    },

    getStructureList() {
      structureList({
        name: undefined,
        status: 1,
      }).then((res) => {
        this.selectDepts = res.data
      });
    },
    roleFilterHandle(roleType) {
      if (roleType) {
        let role = this.rolesSelect.find(item => item.key == roleType)
        return role.value || ''
      } else {
        return ''
      }
    }
  },
  created() {
    this._getList()
    this._allRoles();
    this.getStructureList();
  },
};
</script>
<style lang='less' scoped>
.organizationView {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  .tag {
    border: 0;
    background-color: rgba(232, 244, 255, 0.1);
    color: #FFFFFF
  }

  .tag~.tag {
    margin-top: 10px
  }
}

.commandBtn {
  display: flex;
  flex-direction: row;
  align-items: center;

  .primary {
    color: #1890FF;
  }

  .danger {
    color: #F56C6C;
  }
}

.roleDialog ::v-deep .el-dialog__body {
  max-height: 70vh;
  overflow-y: auto;
}

.tree-border {
  ::v-deep .el-tree-node__expand-icon.is-leaf {
    padding: 6px;
  }
}

::v-deep .onlyRead {
  .el-checkbox {
    pointer-events: none;
    cursor: not-allowed;
  }

  .el-checkbox__inner::after {
    border-color: #c0c4cc !important;
  }

  .el-checkbox__input {
    .el-checkbox__inner {
      background-color: rgb(237, 242, 252);
      border-color: rgb(217, 217, 217);
    }

    &.is-checked {
      .el-checkbox__inner {
        background-color: #f2f6fc;
        border-color: #dcdfe6;
      }
    }
  }
}

.roleDialog ::v-deep .el-tree-node__expand-icon.is-leaf {
  // display: none;
  width: 24px;
  height: 24px;

  &::before {
    content: '';
  }
}
</style>
